import { Component } from '@angular/core';

@Component({
  selector: 'usucampeao-projeto-instauracao-nucleo',
  templateUrl: './projeto-instauracao-nucleo.component.html',
  styleUrls: ['./projeto-instauracao-nucleo.component.scss'],
})
export class ProjetoInstauracaoNucleoComponent { }
